import { enum as enum_, object, optional, string } from 'zod';

import { QuizHintSchema } from './QuizHintSchema';

export const QUESTION_REQUIRED_MESSAGE = 'Question is required';

export const QuizBaseSchema = object({
  id: string(),
  type: enum_(['multiple', 'subjective', 'ox', 'essay']),
  question: string()
    .max(300, QUESTION_REQUIRED_MESSAGE)
    .min(1, QUESTION_REQUIRED_MESSAGE),
  questionRichText: optional(string()),
  questionImageUrl: optional(string()),
  hint: optional(QuizHintSchema),
});
